import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CarsByMake from "../Components/CarsByMake";
import CreditCard from "./assets/credit-card-banner.jpeg";
import './NewArrivals.css';
import { useNavigate } from "react-router-dom";

const NewArrivals = () => {
  const [cars, setCars] = useState([]);
  const [visibleCount, setVisibleCount] = useState(8); // initially show 8 cars
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch car details
    fetch('https://api.saadmotors.com/get-car-details.php')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setCars(data);
      })
      .catch(error => {
        console.error("Error fetching car details:", error);
      });
  }, []);

  const handleCarClick = (carId) => {
    navigate(`/vehicle-details/${carId}`);
  };

  const handleShowMore = () => {
    navigate(`/AllVehicles/`);
  };

  return (
    <section>
      <div className="containers my-5">
        <div className="carousel-bg mb-0">
          <div className="main-title">
            <h2>New Arrival</h2>
            <p>Latest inspected, low-mileage used Thailand cars ready for worldwide export at competitive prices.</p>
          </div>
        </div>
        <div className="row g-3">
          {/* <div className="col-lg-2 col-md-2">
            <div class="list-title">
                <h3>Shop By Make</h3>
            </div>
            <hr className="title-line"></hr>
            <div className="list-group">
              <CarsByMake />
            </div>
          </div> */}
            <div className="col-lg-12 col-md-12">
              <div className="row">
                {cars.slice(0, visibleCount).map((car) => (
                  <div className="col-md-3 col-sm-4 my-2" key={car.id}>
                    <a href={`/vehicle-details/${car.id}`}>
                      <div className="car-card position-relative">
                        <img 
                          src={`https://api.saadmotors.com/${car.images}`} 
                          alt={car.model} 
                        />
                        <div className="car-details">
                          <p className="car-title">{car.maker} {car.model}</p>
                          <p>{car.year} | {car.fuel} | <br /> {car.mileage} Km </p>
                          <div className="car-price">
                            <div className="price-row">
                              <div className="price-label">Price:</div>
                              <div className="price-value">
                                <span>${car.price}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </a>
                </div>
               ))}
              </div>
          </div>
          {/* <div className="col-lg-2 col-md-2">
            <div class="list-title">
                <h3>Shop By Model</h3>
            </div>
            <div className="sidebanner">
              <img
                src={CreditCard}
                alt="Credit Card Banner"
                className="img-sidebanner"
              />
            </div>
            <hr className="title-line"></hr>
          </div> */}
        </div>

       {cars.length > 0 && (
            <div className="show-more text-end">
                <button className="btn btn-lg btn-primary" onClick={handleShowMore}>
                    Show More
                </button>
            </div>
        )}
      </div>
    </section>
  );
};

export default NewArrivals;